module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadingCaseForms) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.loadingCaseForms
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingCaseForms) ? _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Date:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "readonly": "",
      "rules": _vm.dateRules
    },
    slot: "activator",
    model: {
      value: (_vm.localMainForm.deceased_date),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_date", $$v)
      },
      expression: "localMainForm.deceased_date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.localMainForm.deceased_date),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_date", $$v)
      },
      expression: "localMainForm.deceased_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Name:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.deceasedNameRules
    },
    model: {
      value: (_vm.localMainForm.deceased_name),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_name", $$v)
      },
      expression: "localMainForm.deceased_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Gender:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['M', 'F'],
      "rules": _vm.genderRules
    },
    model: {
      value: (_vm.localMainForm.deceased_gender),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_gender", $$v)
      },
      expression: "localMainForm.deceased_gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("中⽂姓名:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    model: {
      value: (_vm.localMainForm.deceased_name_chinese),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_name_chinese", $$v)
      },
      expression: "localMainForm.deceased_name_chinese"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Age:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "rules": _vm.ageRules
    },
    model: {
      value: (_vm.localMainForm.deceased_age),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_age", $$v)
      },
      expression: "localMainForm.deceased_age"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Death Certificate No:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    model: {
      value: (_vm.localMainForm.deceased_death_certificate_no),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_death_certificate_no", $$v)
      },
      expression: "localMainForm.deceased_death_certificate_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Religion:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'Buddhist',
        'Taoist',
        'Catholic',
        'Christian',
        'Free thinker',
        'Hindu',
        'Soka',
        'Others'
      ],
      "rules": _vm.religionRules
    },
    model: {
      value: (_vm.localMainForm.deceased_religion),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_religion", $$v)
      },
      expression: "localMainForm.deceased_religion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Dialect:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'Hokkien',
        'Teochew',
        'Cantonese',
        'Hainanese',
        'Hakka',
        'Shanghainese',
        'Hokchew',
        'Others'
      ],
      "rules": _vm.dialectRules
    },
    model: {
      value: (_vm.localMainForm.deceased_dialect),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_dialect", $$v)
      },
      expression: "localMainForm.deceased_dialect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Location of Wake:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.locationOfWakeRules
    },
    model: {
      value: (_vm.localMainForm.deceased_location_of_wake),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_location_of_wake", $$v)
      },
      expression: "localMainForm.deceased_location_of_wake"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Crematorium / Burial Location:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.burialLocations,
      "rules": _vm.burialLocationsRules
    },
    model: {
      value: (_vm.localMainForm.deceased_burial_location),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_burial_location", $$v)
      },
      expression: "localMainForm.deceased_burial_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Embalming:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-checkbox', {
    model: {
      value: (_vm.localMainForm.deceased_embalming),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_embalming", $$v)
      },
      expression: "localMainForm.deceased_embalming"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64c54e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/Forms.vue
// module id = 975
// module chunks = 1